export default __webpack_public_path__ + "0a62f60c214a3f609f3ff7dd50a34a70.jpg";